import React, { useState, useEffect } from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const DataTable = () => {



  const [marginLeft, setMarginLeft] = useState(
        window.innerWidth >= 992 ? "270px" : "0px"
      );
    
      useEffect(() => {
        const handleResize = () => {
          setMarginLeft(window.innerWidth >= 992 ? "270px" : "0px");
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

  const data = [
    {
      "courseId": "C001",
      "courseName": "Mathematics",
      "courseCode": "MATH101",
      "courseDuration": "6 Months",
      "courseStatus": "Active",
      "courseType": "Offline",
      "startDate": "2025-03-10",
      "endDate": "2025-09-10"
    },
    {
      "courseId": "C002",
      "courseName": "Physics",
      "courseCode": "PHY102",
      "courseDuration": "6 Months",
      "courseStatus": "Completed",
      "courseType": "Online",
      "startDate": "2024-07-15",
      "endDate": "2025-01-15"
    },
    {
      "courseId": "C003",
      "courseName": "Chemistry",
      "courseCode": "CHEM103",
      "courseDuration": "4 Months",
      "courseStatus": "Active",
      "courseType": "Offline",
      "startDate": "2025-04-01",
      "endDate": "2025-08-01"
    },
    {
      "courseId": "C004",
      "courseName": "Biology",
      "courseCode": "BIO104",
      "courseDuration": "5 Months",
      "courseStatus": "Upcoming",
      "courseType": "Hybrid",
      "startDate": "2025-06-20",
      "endDate": "2025-11-20"
    },
    {
      "courseId": "C005",
      "courseName": "Computer Science",
      "courseCode": "CS105",
      "courseDuration": "8 Months",
      "courseStatus": "Active",
      "courseType": "Online",
      "startDate": "2025-02-10",
      "endDate": "2025-10-10"
    }
  ];

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(search.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div style={{ marginLeft}}>
      

      <div
        className="bg-secondary p-3 rounded d-flex justify-content-center align-items-center"
        style={{
          marginTop: screenWidth >= 992 ? "-15px" : "50px", // Corrected Here
        }}
      >
        <h1 className="text-center text-white mt-md-0 mt-5">Class List</h1>
      </div>

      <div className="d-flex justify-content-between align-items-center my-3">
        <Form.Control
          type="text"
          placeholder="Search..."
          className="w-25"
          onChange={(e) => setSearch(e.target.value)}
        />

        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
        </Form.Select>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Course ID</th>
            <th>Course Name</th>
            <th>Course Code</th>
            <th>Duration</th>
            <th>Status</th>
            <th>Type</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <tr key={index}>
                <td>{item.courseId}</td>
                <td>{item.courseName}</td>
                <td>{item.courseCode}</td>
                <td>{item.courseDuration}</td>
                <td>{item.courseStatus}</td>
                <td>{item.courseType}</td>
                <td>{item.startDate}</td>
                <td>{item.endDate}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div className="d-flex justify-content-between align-items-center">
        <p className="text-black">Total Records: {filteredData.length}</p>
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </div>
  );
};

export default DataTable;
